import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { getUser } from './Common/helper';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { usePostHog } from '@posthog/react';

import Header from './Layout/Header';
import Home from './Feature/Home';
import Signup from './Feature/Auth/Signup';
import Login from './Feature/Auth/Login';
import Footer from './Layout/Footer';
import Search from './Feature/SearchPage';
import Profile from './Feature/Profile';
import SalonDetail from './Feature/SalonDetail';
import RetainooDeals from './Feature/RetainooDealsPage';
import ForgotPassword from './Feature/Auth/ForgotPassword';
import ResetPassword from './Feature/Auth/ResetPassword';

// Public routes that don't require authentication
const PUBLIC_ROUTES = [
  '/',
  '/signup',
  '/login',
  '/forgot-password',
  '/account/recover',
  '/search',
  '/deals',
];

// Check if route requires authentication
const isPublicRoute = (pathname) => {
  return PUBLIC_ROUTES.includes(pathname) || pathname.startsWith('/salon-detail/');
};

// Private route wrapper component
function PrivateRoute({ children }) {
  const location = useLocation();
  const user = getUser();

  if (!user && !isPublicRoute(location.pathname)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

function App() {
  const [scroll, setScroll] = useState(false);
  const posthog = usePostHog();

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 150);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const storedUser = getUser();
    if (storedUser) {
      const user = JSON.parse(storedUser);
      posthog?.identify(String(user.id), {
        name: `${user.firstName} ${user.lastName}`,
      });
    }
  }, [posthog]);

  return (
    <div className={scroll ? "app sticky-header" : "app"}>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/account/recover" element={<ResetPassword />} />
          <Route path="/search" element={<Search />} />
          <Route path="/deals" element={<RetainooDeals />} />
          <Route path="/salon-detail/:id" element={<SalonDetail />} />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
        </Routes>
        <Footer />
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        theme="light"
      />
    </div>
  );
}

export default App;
